// ═══════════════════════════════════════════════════════════════
// Firebase Config — LexDriver Recursos
// ═══════════════════════════════════════════════════════════════

import { initializeApp } from "firebase/app";
import { getFirestore, collection, doc, getDocs, getDoc, setDoc, addDoc, updateDoc, deleteDoc, onSnapshot, query, orderBy, where } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword, signInWithPopup, GoogleAuthProvider, signOut, onAuthStateChanged } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyA0VorijpjyaQBqbBuimIpwd5EG4tBsKww",
  authDomain: "lexdriver-491016.firebaseapp.com",
  projectId: "lexdriver-491016",
  storageBucket: "lexdriver-491016.firebasestorage.app",
  messagingSenderId: "570778145293",
  appId: "1:570778145293:web:2c32a20adffc6e999b7b44",
  measurementId: "G-S8V86D41QE"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// ── Referências das coleções ──
const processosRef = collection(db, "processos");
const cobrancasRef = collection(db, "cobrancas");
const fluxoRef = collection(db, "fluxo_caixa");
const usersRef = collection(db, "users");

export {
  db,
  storage,
  auth,
  googleProvider,
  processosRef,
  cobrancasRef,
  fluxoRef,
  usersRef,
  collection, doc, getDocs, getDoc, setDoc, addDoc, updateDoc, deleteDoc, onSnapshot, query, orderBy, where,
  ref, uploadBytes, getDownloadURL, deleteObject,
  signInWithEmailAndPassword, createUserWithEmailAndPassword, signInWithPopup, signOut, onAuthStateChanged
};
